import React, { useState, DragEvent, ChangeEvent, useRef } from 'react';


interface FileWithPreview extends File {
    preview?: string;
}

interface DragAndDropFilesProps {
    handleChange: (files: FileWithPreview[]) => void;
    name?: string;
    multiple?: boolean;
    accept?: string;
    children?: React.ReactNode;
    onDropEnd?: () => void | null;
}

const DragAndDropFiles: React.FC<DragAndDropFilesProps> = ({
    handleChange,
    name = 'file',
    multiple = true,
    children,
    accept = "",
    onDropEnd = null
}) => {
    const [files, setFiles] = useState<FileWithPreview[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDrop = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        const droppedFiles = Array.from(event.dataTransfer.files);
        handleFiles(droppedFiles);
        if (onDropEnd) onDropEnd();
    };

    const handleFileInput = (event: ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = Array.from(event.target.files || []);
        handleFiles(selectedFiles);
    };

    const handleFiles = (newFiles: FileWithPreview[]) => {
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        handleChange(newFiles);
    };

    return (
        <div className="w-full h-full mx-auto" onDragOver={handleDragOver} onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}>
            <input
                type="file"
                multiple={multiple}
                className="hidden"
                ref={fileInputRef}
                name={name}
                onChange={handleFileInput}
                accept={accept || undefined}
            />
            {children ? children :
                <div
                    className="border-2 w-full h-full cursor-pointer border-dashed border-gray-300 rounded-lg p-4  flex flex-col items-center justify-center"
                >
                    <label className="text-center cursor-pointer">
                        <p className="text-xl font-semibold text-gray-700">
                            Drag & Drop your files here
                        </p>
                        <p className="text-lg text-gray-500 mt-2">or click to select files</p>
                    </label>
                </div>
            }
        </div>
    );
};

export default DragAndDropFiles;
